import axios from "axios";
import baseServices from "./base.service";

const list = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_category_list.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const listFront = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_category_list_front.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const get = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_category_get.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const submit = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_category_submit.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const remove = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_category_delete.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const rentalCategoryService = {
  list,
  get,
  submit,
  remove,
  listFront,
};

export default rentalCategoryService;
